export default "__VITE_ASSET__C6ntAF9l__"